import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { RobinProvider } from "./context";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { createApolloClient } from "./graphql";

import "./assets/css/override.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <RobinProvider>
      <BrowserRouter>
        <ApolloProvider client={createApolloClient()}>
          <App />
        </ApolloProvider>
      </BrowserRouter>
    </RobinProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
